import { Components, Inputs } from "@thisgorilla/primate-ds";
import { Formik } from "formik";
import styled, { useTheme } from "styled-components";
import { API_CALLS } from "../../../../../../API/api_calls";
import {
  Divider,
  hideScrollBar,
  LabelContainer,
} from "../../../../../../commonStyles";
import { ArticleProps } from "../../../../../../redux/slices/article/Article";
import { isFormSubmitButtonDisabled } from "../../../../../../utils";
import { FlexRowEnd } from "../../../../../Common/Styles";
import Input from "../../../../../Input";
import { useFindContent } from "../../../useFindContent";
import AudioProps from "../Audio";
import ArticleAudioBackground from "./ArticleAudioBackground";

const AudioCreate = ({
  id,
  setIsAudioCreated,
  onDeleteAudio,
}: AudioProps.AudioCreateProps) => {
  const { typography } = useTheme();
  const {
    content_id,
    post_id,
    content_data,
    article_order,
    content_type,
    row_config,
  } = useFindContent(id) as ArticleProps.WithAudioContent;
  const { title, description } = content_data;

  return (
    <Formik
      initialValues={{ audio_title: title, audio_description: description }}
      onSubmit={() => {}}
      enableReinitialize
    >
      {(formik) => {
        const { values, setFieldValue, validateField } = formik;
        const remainingCharacters =
          500 - (values.audio_description?.length ?? 0);

        return (
          <AudioContainer>
            <FlexRowEnd>
              <Components.IconButton
                disabled={false}
                iconType="X"
                kind="Secondary"
                size="Small"
                onClick={onDeleteAudio}
              />
            </FlexRowEnd>
            <Divider />
            <LabelContainer>
              <Components.Text
                style={{ tokenStyle: typography.Heading.XXS }}
                text="Audio Headline"
                fontWeight="font-weight-semibold"
                lineHeight="line-height-50"
              />
            </LabelContainer>
            <Input
              fieldName="audio_title"
              idPrefix="create-audio"
              isRequired
              placeholder="Add a headline to your audio clip"
              size="Medium"
            />
            <LabelContainer>
              <Components.Text
                style={{ tokenStyle: typography.Heading.XXS }}
                text="Description"
                fontWeight="font-weight-semibold"
                lineHeight="line-height-50"
              />
            </LabelContainer>
            <Inputs.Textarea
              fieldName="audio-description"
              idPrefix="create-audio"
              isRequired
              placeholder="Text"
              size="Medium"
              value={values.audio_description}
              onChangeHandler={(value) => {
                setFieldValue(
                  "audio_description",
                  value.slice(0, 500),
                  false
                ).then(() => {
                  validateField("audio_description");
                });
              }}
              helpText={
                remainingCharacters === 0
                  ? "Max characters reached"
                  : remainingCharacters <= 50
                  ? `${remainingCharacters} characters remaining`
                  : undefined
              }
            />
            <ArticleAudioBackground id={id} />
            <FlexRowEnd>
              <Components.Button
                color="Primary"
                kind="Primary"
                disabled={isFormSubmitButtonDisabled({
                  formik,
                  requiredFileds: {
                    audio_title: true,
                    audio_description: true,
                  },
                })}
                label="Save"
                onClick={() => {
                  API_CALLS.ARTICLE.createOrUpdateArticleContent({
                    article_order,
                    content_type,
                    post_id,
                    content_id,
                    element_role: row_config.element_role,
                    content_data: JSON.stringify({
                      title: formik.values.audio_title,
                      description: formik.values.audio_description,
                    }),
                  }).then(() => {
                    setIsAudioCreated(true);
                  });
                }}
                size="Medium"
              />
            </FlexRowEnd>
          </AudioContainer>
        );
      }}
    </Formik>
  );
};

export default AudioCreate;

const AudioContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem
    ${({ theme }) => theme.spacing["spacing-2"].value}rem
    ${({ theme }) => theme.spacing["spacing-6"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  border: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-s"]};

  * {
    ${hideScrollBar}
  }
`;
